import { Apis } from "../../lib/Apis";

export const useUser = () => {
  const getAllUsers = async (setUsersData, offset = 0, limit = 9) => {
    try {
      const response = await Apis.getAllUsers(offset, limit);
      setUsersData(response.data.data);
      return response.data;
    } catch (error) {
      console.error(
        "🚀 ~ file: useHook.js ~ line 64 ~ getAllUsers ~ error",
        error,
      );
      return error;
    }
  };
  const updateUserStatus = async (id, status) => {
    try {
      const requestBody = {
        id,
        status,
      };
      const response = await Apis.updateUSerStatus(requestBody);
      if (response && response.data) {
        return response;
      } else {
        console.error("Invalid response format:", response);
        return null;
      }
    } catch (error) {
      console.error("Error in Hook:", error.message || error);
      return null;
    }
  };
  const searchUsers = async (
    searchQuery,
    emailQuery,
    statusFilter,
    offset = 0,
    limit = 9,
  ) => {
    try {
      const params = {
        offset,
        limit,
      };

      if (statusFilter !== "") {
        params.status = statusFilter === "true" ? true : false;
      }

      if (searchQuery) {
        params.name = searchQuery;
      }

      if (emailQuery) {
        params.email = emailQuery;
      }

      const response = await Apis.searchUsers(params);
      return response.data;
    } catch (error) {
      console.error(
        "🚀 ~ file: useHook.js ~ line 64 ~ searchUsers ~ error",
        error,
      );
      return error;
    }
  };

  return { getAllUsers, updateUserStatus, searchUsers };
};
